import React, { Component } from 'react';
import { Link, Route } from 'react-router-dom';
import './Err.css';
import MyHelmet from 'components/common/MyHelmet';

class Err extends Component {
	render() {
		return (
			<div id="Page_Err" className="Page">
				<MyHelmet
					title="Error"
				/>
				<div className="wrap">
					<div className="Page_Err-message">
						<h2>Oops...</h2>
						<p>
							Something has gone wrong.<br />
							<Link to="/">See other works instead?</Link>
						</p>
					</div>
				</div>
			</div>
		)
	}
}

export default () => (
	<Route render={(props)=>{
		if(props.staticContext){
			props.staticContext.status = 404;
		}
		return <Err />
	}}/>
);



// WEBPACK FOOTER //
// ./src/components/Pages/Err/Err.jsx